import type { QueryClient } from "@tanstack/react-query";
import { createRootRouteWithContext, Outlet } from "@tanstack/react-router";
// import { TanStackRouterDevtools } from "@tanstack/react-router-devtools";
import { AppToastViewport } from "~/components/AppToastViewport";
import { CocoplusForceUpdateGate } from "~/components/CocoplusForceUpdateGate";
import { InAppNotificationToast } from "~/components/InAppNotificationToast";
import { NativePurchaseBridgeListener } from "~/components/NativePurchaseBridgeListener";
import { Toaster } from "~/components/ui/sonner";
import { guardHokageServiceCutoff } from "~/lib/hokageServiceGuard";

interface RouterContext {
  queryClient: QueryClient;
}

const RootComponent = () => {
  return (
    <>
      <NativePurchaseBridgeListener />
      <CocoplusForceUpdateGate />
      <Outlet />
      <InAppNotificationToast />
      <AppToastViewport />
      <Toaster position="top-center" />
      {/* <TanStackRouterDevtools /> */}
    </>
  );
};

export const Route = createRootRouteWithContext<RouterContext>()({
  // 全ルートの入口。Hokage は締め切り以降サービス終了画面だけに閉じ込める
  beforeLoad: ({ location }) => guardHokageServiceCutoff(location.pathname),
  component: RootComponent,
});
